<template>
  <div>
    <Timeline v-if="hasItems">
      <TimelineItem v-for="timelineItem in dynamicItems" :key="timelineItem.id">
        <p class="time">{{ timelineItem.time }}</p>
        <p class="content" style="text-transform: capitalize;">
          {{ timelineItem.content }}
          <i
            v-if="timelineItem.typeId === 7"
            class="fa fa-link"
            aria-hidden="true"
          ></i>
        </p>
        <p v-if="canUnlink(timelineItem)">
          If this was a mistake click
          <u style="cursor: pointer" @click="unlinkTracker()">here</u> to unlink
          it.
        </p>
      </TimelineItem>
    </Timeline>
    <div v-else>
      <h5>Sorry, there is no information.</h5>
      <h5>Please contact Freighthub for more information.</h5>
    </div>
    <a v-if="showFilteredOnly" href="#!" @click="showFilteredOnly = false"
      >Show more history</a
    >
  </div>
</template>

<script>
export default {
  name: "FreightMovement",
  props: ["timelineItems", "booking"],
  data() {
    return {
      showFilteredOnly: false
    };
  },
  methods: {
    unlinkTracker() {
      this.$emit("unlinkTracker");
    },
    canUnlink(timelineItem) {
      if (!this.booking.tracker_id) {
        return false;
      }
      if (
        timelineItem.typeId === 7 &&
        this.booking.status_id <= 3 &&
        Number(this.booking.tracker_id.toString().substring(4)) ==
          timelineItem.eroadWhereDeviceId
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    hasItems: function() {
      return this.timelineItems && this.timelineItems.length > 0;
    },
    dynamicItems: function() {
      let items = this.timelineItems;
      if (this.showFilteredOnly) {
        const that = this;
        items = this.timelineItems.filter(function(item, index) {
          return item.required || index === that.timelineItems.length - 1;
        });
      }
      return [...items].reverse();
    }
  },
  watch: {
    timelineItems: function(newValue) {
      this.showFilteredOnly = newValue.length > 5;
    }
  }
};
</script>

<style scoped></style>
